import ReactPlayer from 'react-player';
import type { VideoPlayerTypes } from './types';

export const VideoPlayer = ({ controls, autoplay, url }: VideoPlayerTypes) => {
  return (
    <ReactPlayer
      width="100%"
      height="auto"
      controls={controls}
      playing={autoplay}
      volume={0.5}
      src={url}
      style={{
        position: 'relative',
        paddingBottom: '56.25%',
      }}
    />
  );
};
